import isArrayLike from './is-array-like';
export default function last(o) {
    if (isArrayLike(o)) {
        var arr = o;
        return arr[arr.length - 1];
    }
    return undefined;
}
//# sourceMappingURL=last.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/last.js
// module id = 502
// module chunks = 3